module.exports = __webpack_public_path__ + "static/media/ShipstonMobile.51b8f055.png";